const mapboxAT = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
const cesiumAT = process.env.REACT_APP_CESIUM_ACCESS_TOKEN;



const config = {
  map: {
    basemap: 0,
    centerX: -98.579,
    centerY: 39.828,
    centerZ: 5,
    altitude3d: 14771168,
    heading3d: 0,
    tilt3d: 0,
    minzoom: 0,
    maxzoom: 22,
    rotation: 0
  },
  dim: "2d",
  theme: "bg-nid",
  terrainServices: [{

  }],
  basemaps: [
    {
      id: "OpenStreetMap",
      name: "OpenStreetMap",
      oldUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      url: "https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      maxZoom: 19,
      attributions:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      visible: true
    },
    {
      id: "StamenToner",
      name: "Stamen Toner",
      oldUrl: "https://stamen-tiles-{s}.a.ssl.fastly.net/toner/{z}/{x}/{y}.png",
      url: "https://stamen-tiles-{a-d}.a.ssl.fastly.net/toner/{z}/{x}/{y}.png",
      attributions:
        'Map tiles by <a href="https://stamen.com">Stamen Design</a>, <a href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      subdomains: "abcd",
      minZoom: 0,
      maxZoom: 20,
      ext: "png",
      visible: false
    },
    {
      id: "StamenWatercolor",
      name: "Stamen Watercolor",
      oldUrl:
        "https://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.jpg",
      url:
        "https://stamen-tiles-{a-d}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.jpg",
      attributions:
        'Map tiles by <a href="https://stamen.com">Stamen Design</a>, <a href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      subdomains: "abcd",
      minZoom: 1,
      maxZoom: 16,
      ext: "png",
      visible: false
    },
    {
      id: "EsriWorldImagery",
      name: "ESRI World Imagery",
      url:
        "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
      attributions:
        "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
      visible: false
    },
    {
      id: "EsriUSATopoMaps",
      name: "ESRI Topo Maps",
      url:
        "https://services.arcgisonline.com/ArcGIS/rest/services/USA_Topo_Maps/MapServer/tile/{z}/{y}/{x}",
      attributions:
        "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
      visible: false
    },
    {
      id: "EsriWorldShadedRelief",
      name: "ESRI World Hillshade",
      url:
        "https://services.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}",
      attributions:
        "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
      visible: false
    },
    {
      id: "EsriWorldOcean",
      name: "ESRI World Ocean",
      url:
        "https://services.arcgisonline.com/ArcGIS/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}",
      attributions:
        "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
      visible: false
    },
    {
      id: "USGSImageryTopo",
      name: "USGS Imagery/Topo",
      url:
        "https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}",
      attributions:
        "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
      visible: false
    }
  ],
  datasets: [
    // {
  //   uid: "6dfb96b6-7918-4c0f-a01d-eeb4e2f78469",
  //   leaf: false,
  //   teamDatasetId: null,
  //   collapsed: false,
  //   visible: false,
  //   sortOrder: 0,
  //   displayName: 'HSIP',
  //   type: 'Folder'
  // },{
  //   abstract: "The Alaska NFHL data was updated 04-14-2015 and was downloaded 10-7-2015 from: http://msc.fema.gov/portal",
  //   allowEdit: 0,
  //   allowExport: 0,
  //   attribution: "Alaska District Regulatory Division GIS project",
  //   createDate: "2018-03-01T08:54:57.000Z",
  //   createdBy: "1472424242",
  //   createdByUsername: "ryanm",
  //   dsName: "HSIP",
  //   datasetId: 2164,
  //   description: "This layer was created from FEMA's Alaska NFHL layer. 100 year floodplain data was extracted from the S_Fld_Has_Ar layer by extracting the polygons that had a zone type of: Zone A, Zone AO, Zone AH, Zones A1-A30, Zone AE, Zone A99, Zone AR, Zone AR/AE, Zone AR/AO, Zone AR/A1-A30, Zone AR/A, Zone V, Zone VE, and Zones V1-V30.",
  //   displayName: "Airports",
  //   geometryType: "SERVICE",
  //   grids: null,
  //   id: 2286,
  //   keywords: "Regulatory, POA, Flood Data",
  //   labelDefault: 0,
  //   labelEnabled: 0,
  //   layerList: "66",
  //   localTable: null,
  //   maxX: -99.93164063,
  //   maxY: 70.34831756,
  //   maxzoom: null,
  //   metadataUrl: null,
  //   minX: -197.49023438,
  //   minY: 54.5210815,
  //   minzoom: null,
  //   nationalData: 1,
  //   numRows: null,
  //   opacity: 1,
  //   parentUid: "6dfb96b6-7918-4c0f-a01d-eeb4e2f78469",
  //   purpose: " These zones are defined as having a 1 percent annual chance of a flood, therefore, by definition are within the 100 year floodplain.",
  //   q: "100 Year Floodplain Polygon POA Regulatory Regulatory, POA, Flood Data",
  //   rnum: 2,
  //   serviceType: "TileWMS",
  //   status: null,
  //   teamDatasetId: 2286,
  //   teamId: 608,
  //   teamName: "POA Regulatory",
  //   tiled: 0,
  //   type: "MVT",
  //   serviceURL: "https://192.168.17.147/ms/cgi-bin/mapserv?MAP=/u02/mapserver/maps/inundation_test.map&LAYERS=HSIP&TABLE=aiports&mode=tile&tilemode=gmap&tile={x}+{y}+{z}",
  //   uid: "8df5dff4-c876-4e80-8bd9-56d15a6e0e52",
  //   useMapfile: 0,
  //   visible: true
  // }
  ],
  plugins: [
    {
      pluginName: "Left Sidebar Expander"
    },
    // {
    //   pluginName: "SwitchDimensions"
    // },
    {
      pluginName: "ZoomButtons"
    },
    {
      pluginName: "ZoomToInitial"
    },
    // {
    //   pluginName: "NorthButton"
    // },
    {
      pluginName: "BasemapSwitcher"
    },
    {
      pluginName: "Theme Switcher"
    },
    {
      pluginName: "Catalog"
    },
    {
      pluginName: "LayerTree"
    },
    {
      pluginName: "ActiveEvent"
    },
    {
      pluginName: "Remove Layer"
    },
    {
      pluginName: "ZoomHistory"
    },
    {
      pluginName: "ZoomtoExtent"
    },
    {
      pluginName: "Draw Tools"
    },
    {
      pluginName: "MeasureArea"
    },
    {
      pluginName: "PositionText"
    },
    {
      pluginName: "Opacity"
    },
    {
      pluginName: "LoginButton"
    },
    {
      pluginName: "Annotation"
    },
    {
      pluginName: "Bookmarks"
    },
    {
      pluginName: "HelpButton"
    },
    // {
    //   pluginName: "IdentifyTools"
    // },
    {
      pluginName: "Identify CorpsMap"
    },
    // {
    //   pluginName: "Editor"
    // },
    {
      pluginName: "Legend"
    },
    {
      pluginName: "DS Projects"
    },
    {
      pluginName: "Geocoder"
    },
    {
      pluginName: "DsSearch"
    },
    {
      pluginName: "Add Data"
    },
    {
      pluginName: "Vector Search"
    },
    {
      pluginName: "Permalink"
    },
    // {
    //   pluginName: "Map Sheets Explorer"
    // },
    // {
    //   pluginName: "Maps On Demand"
    // }
  ]
};

export default config;